import React, { useEffect, useState } from 'react';
import { Grid } from "@mui/material";
import {
    BreadCrumbs,
    PageTitleWithToolTip,
    AddButton,
    DataGrid
} from "../../Common";
import Routes from '../../../routes';
import { text_commonCellProps, select_commonCellProps } from '../../Common/DataGrid/utils';
import StyledCellLink from '../../Common/DataGrid/CellComponents/StyledCellLink';
import useNavigate from '../../../hooks/useNavigate';

const ManageManufacturers = () => {
    const navigate = useNavigate({ pageName: 'ManageManufacturers' });
    const [refreshNeeded, setRefreshNeeded] = useState(false);
    const [filterOptions, setFilterOptions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(Routes.Manufacturers.TableFilters());
            const data = await response.json();
            setFilterOptions(data);
        }

        fetchData();
    }, [])

    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            ...text_commonCellProps,
        },
        {
            field: 'name',
            headerName: 'Manufacturer',
            ...select_commonCellProps,
            renderCell: ({ row }) => (
                <StyledCellLink
                    primaryLink
                    path={`/ManufacturerDetails/${row.id}`}
                    text={row.name}
                    from={window.location.pathname}
                />
            ),
        },
        {
            field: 'accountTypeName',
            headerName: 'Account Type',
            ...select_commonCellProps,
        },
        {
            field: 'instanceName',
            headerName: 'Instance',
            ...select_commonCellProps,
        },
    ];

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: 'Geek Command Center', to: `/GeekCommandCenter` },
                    { text: 'Manufacturers' }
                ]}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
            >
                <Grid item xs={6} md={6} lg={6} mb={2}>
                    <PageTitleWithToolTip
                        pageTitle="Manufacturers"
                    />
                </Grid>
                <Grid item xs={6} md={6} lg={6} align="right">
                    <AddButton
                        text="Add Manufacturer"
                        onClick={() => navigate.push('/AddManufacturer')}
                    />
                </Grid>
            </Grid>
            <DataGrid
                refresh={refreshNeeded}
                showColumnHeaderFilter
                filterOptions={filterOptions}
                url={Routes.Manufacturers.GetTable()}
                exportButtonURL={Routes.Manufacturers.ExportManufacturers()}
                exportButtonAlt="Export Manufacturers (.csv)"
                noResultText="Oops... It's empty here..."
                noResultText2="Create a new manufacturer or change your search criteria."
                columns={columns}
                getRowId={(row) => row.id}
            />
        </>
    );
}

export default ManageManufacturers;
